import { Palette } from '@infoods/lifebase-ui';

type DrawPointOptions = {
  pointX: number;
  pointY: number;
  strokeColor: string;
};

export const drawPoint = (
  ctx: CanvasRenderingContext2D,
  options: DrawPointOptions,
  palette: Palette,
) => {
  const { pointX, pointY, strokeColor } = options;

  ctx.save();
  ctx.beginPath();

  ctx.strokeStyle = strokeColor;
  ctx.fillStyle = palette.white;
  ctx.lineWidth = 2;
  ctx.arc(pointX, pointY, 4, 0, Math.PI * 2);
  ctx.fill();
  ctx.stroke();

  ctx.restore();
};
